import React, { createElement } from "react";
import { create, supported, registerPlugin, FileStatus, FilePond, FilePondOptionProps } from "filepond";

export { registerPlugin, FileStatus };

export interface IFilePondComponentProps extends FilePondOptionProps {
  acceptedFileTypes?: any;
  chunkUploads?: boolean;
  chunkSize?: number;
  chunkForce?: boolean;
}

const FilePondComponent = (props: IFilePondComponentProps) => {
  const { id, name, className, allowMultiple, required, captureMethod, acceptedFileTypes } = props;

  const [instance, setInstance] = React.useState<FilePond>();
  const [element, setElement] = React.useState();

  React.useEffect(() => {
    if (!supported() || !element) {
      return;
    }

    const options = { ...props };
    const pond = create(element, options);
    setInstance(pond);

    return () => {
      if (instance) {
        instance.destroy();
      }
    };
  }, [element]);

  return createElement(
    "div",
    { className: "filepond--wrapper" },
    createElement("input", {
      type: "file",
      name,
      id,
      accept: acceptedFileTypes,
      multiple: allowMultiple,
      required: required,
      className: className,
      capture: captureMethod,
      ref: (el: any) => setElement(el),
    }),
  );
};

export default FilePondComponent;
